export const API_KEY_QUERY_KEYS = {
  all: ['apiKeys'] as const,
  list: () => [...API_KEY_QUERY_KEYS.all, 'list'] as const,
  detail: (id: string) => [...API_KEY_QUERY_KEYS.all, 'detail', id] as const,
} as const
